module.exports = __webpack_public_path__ + "img/clients.85e2c5d5.svg";